import { render, staticRenderFns } from "./setting-online-distribution.vue?vue&type=template&id=3c07a224&"
import script from "./setting-online-distribution.vue?vue&type=script&lang=js&"
export * from "./setting-online-distribution.vue?vue&type=script&lang=js&"
import style0 from "./setting-online-distribution.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports